import React, { useState } from "react";

/**
 * Small inline info tooltip — shows a popover on hover/focus.
 * Usage: <InfoTooltip text="This $3.85 is a transaction fee" />
 */
export default function InfoTooltip({ text, size = 14, className = "", placement = "top" }) {
  const [open, setOpen] = useState(false);
  const posStyle =
    placement === "bottom"
      ? { top: "calc(100% + 6px)", bottom: "auto" }
      : { bottom: "calc(100% + 6px)", top: "auto" };
  return (
    <span
      className={`relative inline-flex items-center align-middle ${className}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label="More info"
        tabIndex={0}
        data-testid="info-tooltip-trigger"
        className="inline-flex items-center justify-center rounded-full border focus:outline-none focus:ring-2"
        style={{
          width: size + 4,
          height: size + 4,
          borderColor: "var(--gf-border-strong)",
          color: "var(--gf-text-muted)",
          background: "var(--gf-bg-soft)",
          fontFamily: "Georgia, serif",
          fontSize: Math.round(size * 0.75),
          lineHeight: 1,
          fontStyle: "italic",
        }}
      >
        i
      </button>
      {open && (
        <span
          role="tooltip"
          data-testid="info-tooltip-content"
          className="absolute left-1/2 -translate-x-1/2 z-50 max-w-[240px] rounded-md border px-3 py-2 text-xs shadow-md pointer-events-none whitespace-normal text-left"
          style={{
            ...posStyle,
            borderColor: "var(--gf-border-strong)",
            background: "var(--gf-surface)",
            color: "var(--gf-text)",
            minWidth: 180,
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
}
